import { useCallback, useState } from 'react';
import { useDebouncedEffect } from '../../../../../Helpers/CustomHooks';
import { ServiceClient } from '../../../../../Services/ServiceClient';

export const useTeamSearch = (query, setIsLoading, setIsOpen, teamCodePrefix, existingTeams) => {
  const [teams, setTeams] = useState([]);

  const findTeams = useCallback(() => {
    if (!query || query.trim().length === 0 || query === teamCodePrefix) {
      setTeams([]);
      return;
    }
    setIsLoading(true);
    ServiceClient.findTeams(
      query,
      data => {
        if (data?.length > 0) {
          setIsLoading(false);
          setTeams(data);
          setIsOpen(true);
        } else {
          setIsLoading(false);
          setTeams([]);
        }
      },
      () => {
        setIsLoading(false);
        setTeams([]);
        setIsOpen(false);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  useDebouncedEffect(findTeams, 500);

  return returnTeams(teams, existingTeams);
};

const returnTeams = (foundTeams, existingTeams) => {
  return foundTeams.filter(team => !existingTeams.some(existingTeam => existingTeam.codePrefix === team.codePrefix));
};
